import {ALTERAR_COMPRADOR_VOLTA, ALTERAR_PASSAGEIRO_VOLTA} from '../types'

export function alterarPassageiroVolta (passageiro) {
  return {
    type: ALTERAR_PASSAGEIRO_VOLTA,
    payload: passageiro
  }
}

export function alterarCompradorVolta (passageiro) {
  return {
    type: ALTERAR_COMPRADOR_VOLTA,
    payload: passageiro
  }
}
